var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#E0E0E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 41.7932L14 36.5248M14 36.5248L19.1667 31.2563M14 36.5248H27.7778C30.6313 36.5248 32.9444 34.1661 32.9444 31.2563V29.5001M26.0556 29.5001V27.744C26.0556 24.8343 28.3687 22.4755 31.2222 22.4755H45M45 22.4755L39.8333 27.744M45 22.4755L39.8333 17.207",
    stroke: "#251163",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.eded7f74071754d795120c804de9df65.svg";
export { ForwardRef as ReactComponent };